// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-content[data-v-4352114e] {\n  margin-top: 0 !important;\n  margin-bottom: 20px;\n}\nselect[data-v-4352114e] {\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
